module.exports = __webpack_public_path__ + "components/country-flag/static/um-89ae5c7167a46fcbc8ef016b26a9cdc0.svg";